<script lang="ts">
  import HashtagIcon from '$icons/HashtagIcon.svelte';
  import { cn } from '$lib/utils/misc';
  import type { ComponentType } from 'svelte';

  export let variant:
    | 'primary'
    | 'secondary'
    | 'gold'
    | 'gold-outline'
    | 'silver'
    | 'muted'
    | 'mint' = 'primary';
  export let size: 'xxs' | 'xs' | 'sm' = 'sm';
  export let icon: ComponentType | null | undefined = undefined;

  /**
   * @deprecated In favor of the `variant` prop
   */
  export let primary = false;

  /**
   * @deprecated In favor of the `variant` prop
   */
  export let tertiary = false;

  const sizeClasses = {
    xxs: {
      text: 'h-5 text-[9px] px-1.5',
      icon: 'h-2.5 w-2.5',
    },
    xs: {
      text: 'h-6 text-[10px] sm:text-xs px-2',
      icon: 'h-5 w-3 sm:h-3.5 sm:w-3.5',
    },
    sm: {
      text: 'h-7 text-sm px-3',
      icon: 'h-4 w-4',
    },
  };

  $: baseClasses = `
    inline-flex items-center justify-start gap-x-1.5 
    rounded border font-normal
    whitespace-nowrap
    ${sizeClasses[size].text}
  `;

  $: iconClasses = sizeClasses[size].icon;

  // Handle deprecated props while maintaining backward compatibility
  $: effectiveVariant = primary ? 'primary' : tertiary ? 'secondary' : variant;

  $: variantClasses = (() => {
    switch (effectiveVariant) {
      case 'primary':
        return 'border-transparent bg-mint-dark-4 text-mint-dark-11 hover:bg-mint-dark-5';
      case 'gold':
        return 'border-amber-400/30 bg-amber-900/30 text-amber-400';
      case 'gold-outline':
        return 'border-amber-400/50 bg-transparent text-amber-400 hover:bg-amber-900/20';
      case 'silver':
        return 'border-gray-300/20 bg-gray-300/10 text-gray-200 hover:bg-gray-300/20';
      case 'muted':
        return 'border-gray-dark-6 bg-transparent text-gray-dark-11 hover:bg-gray-dark-4';
      case 'mint':
        return 'border-mint-dark-11/30 bg-mint-dark-11/10 text-mint-dark-11 hover:bg-mint-dark-11/20';
      default:
        return 'border-transparent bg-gray-dark-4 text-gray-dark-12 hover:bg-gray-dark-5';
    }
  })();

  $: IconComponent = icon === undefined ? HashtagIcon : icon;
</script>

<div class={cn('font-architekt', baseClasses, variantClasses, $$props.class)}>
  {#if IconComponent}
    <svelte:component this={IconComponent} class={iconClasses} />
  {/if}
  <span>
    <slot />
  </span>
</div>
